import React from 'react';
import usePageTitle from '../hooks/usePageTitle';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Product = () => {
  usePageTitle('Product');

  const products = [
    {
      id: 1,
      name: "Fast Connector",
      speed: "100 Mbps",
      price: "Rp 299,000",
      features: ["High-speed internet", "24/7 support", "Free installation", "No data cap"],
      image: "/images/products/fastcon.png"
      
    },
    {
      id: 2,
      name: "Residential Fiber 500Mbps", 
      speed: "500 Mbps",
      price: "Rp 599,000",
      features: ["Ultra-fast internet", "Priority support", "Free installation", "No data cap", "Wi-Fi 6 router"],
      image: "/images/products/fiber-500.jpg"
    },
    {
      id: 3,
      name: "Business Fiber 1Gbps",
      speed: "1 Gbps",
      price: "Rp 1,299,000",
      features: ["Enterprise-grade speed", "Dedicated support", "SLA guarantee", "Static IP", "24/7 monitoring"],
      image: "/images/products/fiber-business.jpg"
    },
    {
      id: 4,
      name: "Enterprise Fiber 10Gbps",
      speed: "10 Gbps", 
      price: "Custom Quote",
      features: ["Maximum performance", "Dedicated account manager", "99.9% uptime SLA", "Multiple static IPs", "Redundant connection"],
      image: "/images/products/fiber-enterprise.jpg"
    },
    {
      id: 5,
      name: "Fiber Optic Cable",
      category: "Infrastructure",
      price: "From Rp 50,000/meter",
      features: ["Single-mode & Multi-mode", "Indoor/Outdoor rated", "High durability", "Low signal loss", "Custom lengths available"],
      image: "/images/products/fiber-cable.jpg"
    },
    {
      id: 6,
      name: "Network Equipment",
      category: "Hardware",
      price: "Varies",
      features: ["Optical switches", "Media converters", "Patch panels", "Connectors & adapters", "Professional installation"],
      image: "/images/products/network-equipment.jpg"
    }
  ];

  return (
    <div className="product-page">
      <Header />
      
      <main className="main-content">
        <section className="product-hero">
          <div className="container">
            <div className="hero-content">
              <h1>Our Fiber Optic Products</h1>
              <p>Discover our comprehensive range of fiber optic internet plans and infrastructure solutions designed to meet every connectivity need.</p>
            </div>
          </div>
        </section>

        <section className="products-section">
          <div className="container">
            <div className="section-header">
              <h2>Internet Plans</h2>
              <p>Choose the perfect plan for your home or business</p>
            </div>
            
            <div className="products-grid">
              {products.filter(product => product.speed).map(product => (
                <div key={product.id} className="product-card">
                  <div className="product-image">
                    <img src={product.image} alt={product.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </div>
                  <div className="product-info">
                    <h3>{product.name}</h3>
                    <div className="product-speed">{product.speed}</div>
                    <div className="product-price">{product.price}<span>/month</span></div>
                    <ul className="product-features">
                      {product.features.map((feature, index) => (
                        <li key={index}>
                          <i className="fas fa-check"></i>
                          {feature}
                        </li>
                      ))}
                    </ul>
                    <button className="product-btn">Choose Plan</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="infrastructure-section">
          <div className="container">
            <div className="section-header">
              <h2>Infrastructure Solutions</h2>
              <p>Professional fiber optic infrastructure for businesses and service providers</p>
            </div>
            
            <div className="products-grid">
              {products.filter(product => product.category).map(product => (
                <div key={product.id} className="product-card">
                  <div className="product-image">
                    <img src={product.image} alt={product.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                  </div>
                  <div className="product-info">
                    <h3>{product.name}</h3>
                    <div className="product-category">{product.category}</div>
                    <div className="product-price">{product.price}</div>
                    <ul className="product-features">
                      {product.features.map((feature, index) => (
                        <li key={index}>
                          <i className="fas fa-check"></i>
                          {feature}
                        </li>
                      ))}
                    </ul>
                    <button className="product-btn">Request Quote</button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="product-cta">
          <div className="container">
            <div className="cta-content">
              <h2>Need a Custom Solution?</h2>
              <p>Our team of experts can design a tailored fiber optic solution for your specific requirements.</p>
              <button className="cta-btn">Contact Our Experts</button>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Product;